import React from 'react';
import Card from '../../ui/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const EngagementTrendChart: React.FC = () => {
  const data = [{
    week: 'Week 1',
    timeOnPage: 3.2,
    sessionDepth: 4.1,
    pageViews: 2.8
  }, {
    week: 'Week 2',
    timeOnPage: 3.4,
    sessionDepth: 4.3,
    pageViews: 2.9
  }, {
    week: 'Week 3',
    timeOnPage: 3.1,
    sessionDepth: 4.0,
    pageViews: 2.7
  }, {
    week: 'Week 4',
    timeOnPage: 3.5,
    sessionDepth: 4.5,
    pageViews: 3.1
  }, {
    week: 'Week 5',
    timeOnPage: 3.3,
    sessionDepth: 4.2,
    pageViews: 2.9
  }, {
    week: 'Week 6',
    timeOnPage: 3.6,
    sessionDepth: 4.6,
    pageViews: 3.2
  }, {
    week: 'Week 7',
    timeOnPage: 3.4,
    sessionDepth: 4.4,
    pageViews: 3.0
  }, {
    week: 'Week 8',
    timeOnPage: 3.7,
    sessionDepth: 4.8,
    pageViews: 3.3
  }, {
    week: 'Week 9',
    timeOnPage: 3.5,
    sessionDepth: 4.5,
    pageViews: 3.1
  }, {
    week: 'Week 10',
    timeOnPage: 3.8,
    sessionDepth: 4.9,
    pageViews: 3.4
  }, {
    week: 'Week 11',
    timeOnPage: 3.6,
    sessionDepth: 4.7,
    pageViews: 3.2
  }, {
    week: 'Week 12',
    timeOnPage: 3.9,
    sessionDepth: 5.1,
    pageViews: 3.5
  }];
  return <Card className="p-6 mb-8" data-id="element-7454">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7455">
        User Engagement Trend
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7456">
        Weekly engagement metrics over 12 weeks
      </p>
      <ResponsiveContainer width="100%" height={350} data-id="element-7457">
        <LineChart data={data} data-id="element-7458">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7459" />
          <XAxis dataKey="week" tick={{
          fontSize: 11
        }} angle={-45} textAnchor="end" height={80} data-id="element-7460" />
          <YAxis tick={{
          fontSize: 12
        }} data-id="element-7461" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} data-id="element-7462" />
          <Legend data-id="element-7463" />
          <Line type="monotone" dataKey="timeOnPage" stroke="#3b82f6" strokeWidth={3} name="Time on Page (min)" dot={{
          r: 4
        }} data-id="element-7464" />
          <Line type="monotone" dataKey="sessionDepth" stroke="#10b981" strokeWidth={3} name="Session Depth (pages)" dot={{
          r: 4
        }} data-id="element-7465" />
          <Line type="monotone" dataKey="pageViews" stroke="#f59e0b" strokeWidth={3} name="Avg Page Views" dot={{
          r: 4
        }} data-id="element-7466" />
        </LineChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7467">
        <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-7468">
          <div className="text-center" data-id="element-7469">
            <div className="text-gray-600" data-id="element-7470">Avg Time on Page</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-7471">3.5 min</div>
            <div className="text-xs text-green-600 mt-1" data-id="element-7472">
              +8.3% vs last period
            </div>
          </div>
          <div className="text-center" data-id="element-7473">
            <div className="text-gray-600" data-id="element-7474">Avg Session Depth</div>
            <div className="text-xl font-bold text-green-600" data-id="element-7475">4.5 pages</div>
            <div className="text-xs text-green-600 mt-1" data-id="element-7476">
              +12.5% vs last period
            </div>
          </div>
          <div className="text-center" data-id="element-7477">
            <div className="text-gray-600" data-id="element-7478">Avg Page Views</div>
            <div className="text-xl font-bold text-orange-600" data-id="element-7479">3.1</div>
            <div className="text-xs text-green-600 mt-1" data-id="element-7480">
              +10.7% vs last period
            </div>
          </div>
        </div>
      </div>
    </Card>;
};
export default EngagementTrendChart;